import { render } from "./BomValidationResultsElementsSendToSearchModal.vue?vue&type=template&id=22ce7027"
import script from "./BomValidationResultsElementsSendToSearchModal.vue?vue&type=script&lang=js"
export * from "./BomValidationResultsElementsSendToSearchModal.vue?vue&type=script&lang=js"

import "./BomValidationResultsElementsSendToSearchModal.vue?vue&type=style&index=0&id=22ce7027&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtnToggle,QBtnGroup,QBtn,QDialog});qInstall(script, 'directives', {ClosePopup});
